import React from 'react'
import PropTypes from 'prop-types'
import LandingPage from 'components/LandingPage'
import trackUrlConversion from 'utils/trackUrlConversion'

import './styles.sass'

export default class LoginScreen extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  login = () => {
    return this.props.rootStore.authStore.login().then(this.afterAuthenticate)
  }

  signup = () => {
    return this.props.rootStore.authStore.signup({ hideLogin: true }).then(this.afterAuthenticate).then(trackUrlConversion)
  }

  afterAuthenticate = (success) => {
    if (!success) {
      return
    }

    const { location } = this.props
    if (location.state && location.state.nextPathname) {
      this.context.router.replace(location.state.nextPathname)
    } else {
      this.context.router.replace('/')
    }
  }

  render () {
    return (
      <LandingPage
        onSignupClick={this.signup}
        onLoginClick={this.login}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/Login/index.jsx